import {
  useEmbedConfigureStore,
  type IComponentSettings,
  type IInputFiles
} from '@/stores/embeds/embedConfigure.store'
import { useIdeStore } from '@/stores/embeds/ide.store'
import { JDOODLEBLOCKSNAMES } from '@/utils/embeds/editorMeta'
import { cloneDeep } from 'lodash-es'
/**
 * On setting change
 */
const onSettingChange = () => {
  const settongs = useEmbedConfigureStore().getComponentSettings?.find(
    (componentSetting: IComponentSettings) =>
      componentSetting.componentName === JDOODLEBLOCKSNAMES.INPUTFILECOMP
  )?.configStyle
  const canEdit = settongs?.find((setting) => setting.id === 'canUpload')?.value || 'true'
  useIdeStore().setInputFilesCanUpload(canEdit === 'true' || false)
}
/**
 * Get default libs
 */
const getDefaultInputFiles = () => {
  const inputFiles: IInputFiles[] =
    cloneDeep(useEmbedConfigureStore().getEmbedConfig?.inputFiles) || []
  useIdeStore().setInputFiles(inputFiles)
}
/**
 * Init language list
 */
const initInputFiles = async () => {
  await getDefaultInputFiles()
}
/**
 * ask backend to remove temp files
 */
const removeTempFiles = async () => {
  const diferentFiles: IInputFiles[] = []

  useEmbedConfigureStore().getEmbedConfig?.inputFiles.forEach((file) => {
    if (!useIdeStore().inputFiles?.find((f) => f.path === file.path)) {
      diferentFiles.push(file)
    }
  })
  // if (diferentFiles.length > 0) console.log('diferentFiles', diferentFiles)
}
/**
 * Eject stdin argus
 */
const destroyInputFiles = async () => {
  await removeTempFiles()
  getDefaultInputFiles()
}
export default {
  initInputFiles,
  onSettingChange,
  removeTempFiles,
  destroyInputFiles
}
